import React, { useEffect, useState } from 'react';
import { Link } from 'react-router-dom';
import { onAuthStateChanged } from 'firebase/auth';
import { doc, getDoc } from 'firebase/firestore';
import { FaMoon, FaSun } from 'react-icons/fa';
import { auth, db } from '../../firebase';
import { useLanguage } from '../../context/LanguageContext.jsx';
import { useTheme } from '../../context/ThemeContext';
import logo from '../../photos/logosonhal.png';
import './Header.css';

const Header = () => {
  const [user, setUser] = useState(null);
  const [isAdmin, setIsAdmin] = useState(false);
  const [loading, setLoading] = useState(true);
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const { isDarkMode, toggleTheme } = useTheme();
  const { lang, toggleLang } = useLanguage();

  useEffect(() => {
    const unsubscribe = onAuthStateChanged(auth, async (nextUser) => {
      if (!nextUser) {
        setUser(null);
        setIsAdmin(false);
        setLoading(false);
        return;
      }

      setUser(nextUser);
      try {
        const docRef = doc(db, 'users', nextUser.uid);
        const docSnap = await getDoc(docRef);
        setIsAdmin(Boolean(docSnap.exists() && docSnap.data().isAdmin));
      } catch {
        setIsAdmin(false);
      } finally {
        setLoading(false);
      }
    });

    return () => unsubscribe();
  }, []);

  const toggleMenu = () => {
    setIsMenuOpen((prev) => !prev);
  };

  return (
    <header className="main-header">
      <div className="nav-container">
        <div className="logo-container">
          <img src={logo} alt="SteamNearMe Logo" className="your-logo" />
          <h1 className="integra-logo" translate="no">SteamNearMe</h1>
        </div>

        <div className={`hamburger ${isMenuOpen ? 'open' : ''}`} onClick={toggleMenu}>
          <span></span>
          <span></span>
          <span></span>
        </div>

        <nav className={isMenuOpen ? 'open' : ''}>
          <Link to="/" onClick={toggleMenu}>Etkinlikler</Link>
          <a
            href="https://integra3646.com"
            target="_blank"
            rel="noopener noreferrer"
            onClick={toggleMenu}
          >
            Hakkımızda
          </a>

          {user ? (
            <>
              <Link to="/içerik-seç" onClick={toggleMenu}>İçerik Oluştur</Link>
              <Link to="/benim-etkinliklerim" onClick={toggleMenu}>Benim Etkinliklerim</Link>
              {isAdmin && !loading && <Link to="/içerik-onayla" onClick={toggleMenu}>İçerik Onayla</Link>}
              <Link to="/profil" onClick={toggleMenu}>Profil</Link>
            </>
          ) : (
            <>
              <Link to="/giriş-yap" onClick={toggleMenu}>Giriş Yap</Link>
              <Link to="/hesap-oluştur" onClick={toggleMenu}>Hesap Oluştur</Link>
            </>
          )}

          <button
            onClick={() => {
              toggleLang();
              setIsMenuOpen(false);
            }}
            className="lang-toggle mobile"
          >
            {lang === 'en' ? 'EN' : 'TR'}
          </button>

          <button onClick={toggleTheme} className="theme-toggle mobile">
            {isDarkMode ? <FaSun /> : <FaMoon />}
            <span>Tema Değiştir</span>
          </button>
        </nav>

        <button onClick={toggleTheme} className="theme-toggle desktop">
          {isDarkMode ? <FaSun /> : <FaMoon />}
        </button>

        <button onClick={toggleLang} className="lang-toggle desktop">
          {lang === 'en' ? 'EN' : 'TR'}
        </button>
      </div>
    </header>
  );
};

export default Header;
